import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';
import { LocalRecipeBoxData } from './local-recipe-box-data';
import { Injectable } from '@angular/core';
import { FirebaseStorage } from '../../../providers/firebase-storage';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from '../../../config/app-settings';
//import { Storage } from '../../../providers/Storage';
//import { Utils } from '../../../providers/utils';
//import { LocalStorageCodes } from '../../../core/codes';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/combineAll';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeAll';

@Injectable()
export class GuestRecipeBoxData {

    constructor(
        private firebaseStorage: FirebaseStorage,
        public settings: AppSettings,
        public localRecipeBox: LocalRecipeBoxData,
        public afw: AngularFireDatabaseWrapper
    ) {
    }
    public cleanData() {
        console.log('----------------------cleanData');
        let data = [];
        return this.localRecipeBox.set(data,'guest');
    }
    // public getRecipe(id) {
    //     let strgRef = FireBaseObjectNames.RECIPES + '/' + id;
    //     var result = this.afw.object(strgRef, undefined, true);
    //     return result;
    // }
    
    public getUserRecipes(uid?) {
        return Observable.fromPromise(this.localRecipeBox.search(uid ? uid : "guest")).map((userRecipes: any) => {
            return userRecipes;
        });

    }
    public remove(userId,recipe) {
       let recipeId = recipe.$key !== undefined ? recipe.$key : recipe.$id;
        return this.localRecipeBox.remove( userId ? userId : "guest",recipeId);
      
    }
    public add( userId, recipe) {
        var userRecipe = {
            title: recipe.title,
            description: recipe.description,
            thumbnail: recipe.thumbnail,
            keyword: recipe.title + " " + recipe.description + " " + recipe.tags + " " + recipe.pansize + " " + recipe.pansize + " " + recipe.cookTime + " min " + recipe.prepareTime + " min ",
            categories: recipe.categories,
            pansize: recipe.pansize,
            prepareTime: recipe.prepareTime
            // recipeId: recipe.recipeId
        };
       let recipeId = recipe.$key !== undefined ? recipe.$key : recipe.$id;

        return this.localRecipeBox.add(userId ? userId : "guest",recipeId, userRecipe);


    }

    public get(userId, recipeId) {
        return this.getUserRecipes(userId).map(userRecipes => {
            return _.find(userRecipes, (userRecipe: any, key) => {
                return key == recipeId;
            })
        })
    }
    public _genKey() {
        var length = 8,
            timestamp = +new Date;

        var _getRandomInt = function (min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
        var ts = timestamp.toString();
        var parts = ts.split("").reverse();
        var id = "";

        for (var i = 0; i < length; ++i) {
            var index = _getRandomInt(0, parts.length - 1);
            id += parts[index];
        }
        return id;
    }
    
    public syncLocalToRemote(recipeId, userRecipe, userId?)
    {
        return new Promise((resolve, reject) => {
            // // Get timestamp
            // var timeStamp = (<any>firebase.database).ServerValue.TIMESTAMP;
            
            // let strgRef = FireBaseObjectNames.USER_RECIPES + '/' + userId + '/' + recipeId;
            // let timestampRef = FireBaseObjectNames.USER_RECIPES + '/' + userId;
            // this.afw.object(strgRef).set(userRecipe).then(() => {
            //     return this.updateTimeStampModified(timestampRef);
            // });
            resolve(true);
            
        });
    }

}


// WEBPACK FOOTER //
// ./src/modules/recipes/providers/guest-recipe-box-data.ts